module.exports = __webpack_public_path__ + "style/img/Group 1949.00fa755e.png";